import {doc, getDoc} from "firebase/firestore";
import {Auth, Firestore} from "../../firebase.js";

export function useFbGetUser() {
    return () => {
        return getDoc(doc(Firestore, "users", Auth.currentUser.uid))
            .then((res) => {
                return res.data();
            })
    };

}
